import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { autoChecklistService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type AuroraOutcomeValuesProps = {
	name: string;
	value: number;
	displayName: string;
};

type GidentifyAuroraOutcomeFieldMutationProps = {
	id: string;
	values: AuroraOutcomeValuesProps;
	ownerType?: string;
	onSuccessHandler?: Function;
};

const useGidentifyAuroraOutcomeFieldMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id, values, ownerType }: GidentifyAuroraOutcomeFieldMutationProps) =>
			autoChecklistService.setGidentifyOwnerAuroraOutcome(
				id,
				values.name,
				ownerType,
			),
		{
			onSuccess(_data, { onSuccessHandler }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Field has been updated successfully",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useGidentifyAuroraOutcomeFieldMutation;
